import { createActionTypes } from "@helpers/redux-helpers";

export const createManualVerificationActionTypes = createActionTypes(
  "manual-verification/create",
);
